import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface Market {
  name: string;
  market_id: string;
}

export interface MarketsService {
  markets$: Observable<Market[]>;
}

export const BILLING_MARKETS_SERVICE = new InjectionToken<MarketsService>(
  '[Billing Market Service]: Markets are required to hydrate market information in billing components',
);

export const CHANGE_INVOICE_DATE_ON_SAME_DAY_ERROR = 'nextRenewal cannot be edited if the current invoice day is today';
